
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

const DefaultColumnSelector = ({ onClose }) => {
    const defaultColumn = ['Operations', 'Finance', 'Admin']

    ////const [selectedColumns, setSelectedColumns] = useState(sessionStorage.getItem("DefaultTab") || "");


    const handleColumnToggle = (columnField) => {
        ////setSelectedColumns(columnField);
        sessionStorage.setItem("DefaultTab", columnField)
        onClose(columnField);
    };
   
    return (
        <>
            {
           
                defaultColumn.map(column => (
                    <Dropdown.Item onClick={() => handleColumnToggle(column)} key={`grid-${column}`}>
                        <div>
                            <input
                                type="checkbox"
                                style={{ display: 'none' }}
                                id={column}
                                value={column}
                                checked={sessionStorage.getItem("DefaultTab")  === column}
                                onChange={() => handleColumnToggle(column)}
                            />
                            {sessionStorage.getItem("DefaultTab") === column && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" className="bi bi-check" viewBox="0 0 16 16">
                                <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z" />
                            </svg>}
                            <span style={{ fontSize: '13px' }} >{column}</span>

                        </div></Dropdown.Item>
                ))
            }
            
        </>
    );
};

export default DefaultColumnSelector;
